/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TagLink from './TagLink';

/**
 * The Tag model module.
 * @module model/Tag
 * @version V1
 */
class Tag {
    /**
     * Constructs a new <code>Tag</code>.
     * @alias module:model/Tag
     */
    constructor() { 
        
        Tag.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Tag</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Tag} obj Optional instance to populate.
     * @return {module:model/Tag} The populated <code>Tag</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Tag();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('linkedItems')) {
                obj['linkedItems'] = ApiClient.convertToType(data['linkedItems'], [TagLink]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Tag</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Tag</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        if (data['linkedItems']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['linkedItems'])) {
                throw new Error("Expected the field `linkedItems` to be an array in the JSON data but got " + data['linkedItems']);
            }
            // validate the optional field `linkedItems` (array)
            for (const item of data['linkedItems']) {
                TagLink.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
Tag.prototype['id'] = undefined;

/**
 * @member {Number} accountId
 */
Tag.prototype['accountId'] = undefined;

/**
 * @member {String} name
 */
Tag.prototype['name'] = undefined;

/**
 * @member {Date} createdAt
 */
Tag.prototype['createdAt'] = undefined;

/**
 * @member {Array.<module:model/TagLink>} linkedItems
 */
Tag.prototype['linkedItems'] = undefined;






export default Tag;

